const initialState = {
  status: "invalid",
  data: {},
  packer: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "PACKER_DASHBOARD_UPDATING":
      return {
        ...state,
        status: "updating",
      };
    case "PACKER_DASHBOARD_EMPTY": {
      return {
        status: "success",
        data: {},
        packer: null,
      };
    }
    case "PACKER_DASHBOARD_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "PACKER_DASHBOARD_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
        packer: action.packer,
      };
    case "PACKER_DASHBOARD_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
